import { encode, decode } from 'base64url';

export default class NavigationService {
    /* @ngInject */
    constructor($state, $transitions, $window) {
        this.$state = $state;
        this.$transitions = $transitions;
        this.$window = $window;

        this.onExit(this.updatePreviousState.bind(this), true);
    }

    updatePreviousState() {
        this.navigated = true;
    }

    navigateBack() {
        if (this.navigated) {
            return this.$window.history.back();
        }

        return this.$state.go('authorized');
    }

    onExit(callback, once) {
        return this.on(this.$transitions.onExit, callback, once);
    }

    onSuccess(callback, once) {
        return this.on(this.$transitions.onSuccess, callback, once);
    }

    on(hook, callback, once) {
        let handler = hook({}, (...args) => {
            if (once) {
                handler();
            }

            return callback(...args);
        });

        return handler;
    }

    getRedirectUrl(state, params) {
        return encode(JSON.stringify({
            state,
            params
        }));
    }

    getStateFromRedirectUrl(url) {
        try {
            return JSON.parse(decode(url));
        } catch (exception) {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/service/navigation.service.js